<template>
  <div class="slogan-container">
    <div class="content">
      <TextSlider :text="dataSource.value" :duration="20"></TextSlider>
    </div>
  </div>
</template>

<script>
import TextSlider from "@/components/TextSlider";
export default {
  name: "SloganComp",
  components: { TextSlider },
  props: {
    dataSource: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data() {
    return {};
  },
  methods: {}
};
</script>

<style lang="less" scoped>
.slogan-container {
  width: 100%;
  background: rgba(173, 173, 173, 0.15);
  border-radius: 8px 8px 8px 8px;
  padding: 6px;
  .content {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 8px;
    background: rgba(244, 248, 255, 0.75);
    font-weight: bold;
    font-size: 16px;
    color: #45474a;
    line-height: 19px;
    padding: 8px 10px;
    text-align: center;
    overflow: hidden;
  }
}
</style>
